const Footer = () => {
  return (
    <article className="footer">
      <a
        href="https://github.com/abhikashbabu/"
        target="_blank"
        rel="noreferrer"
      >
        Designed & Built by Abhikash Babu &copy;2024
      </a>
    </article>
  );
};

export default Footer;
